import React, { useMemo, useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import AutomaticReportPopup from "./AutomaticReportPopup";
import ManualReportPop from "./ManualReportPop";

const GenerateReport = ({ open, onCancel }) => {
  const [selectedReport, setSelectedReport] = useState("");
  const [automaticReportPopup, setAutomaticReportPopup] = useState(false);
  const [manualReportPopup, setManualReportPopup] = useState(false);
  const reportType = useMemo(
    () => [
      { label: "Automatically", value: "automatically" },
      { label: "Manually", value: "manually" },
    ],
    []
  );

  const handleSelect = (value) => {
    setSelectedReport(value);

    if (value === "automatically") {
      setAutomaticReportPopup(true);
    } else if (value === "manually") {
      setManualReportPopup(true);
    }
  };
const handleCancel=()=>{
  setManualReportPopup(false)
 onCancel();
}
  return (
    <div>
      <div>
        {!automaticReportPopup && !manualReportPopup && (
          <DailogBox open={open} onCancel={onCancel} width={700}>
            <div className="flex items-center  gap-2 text-xl  font-bold">
              <TextStyles color="gradient">
                Automatically Generate Report
              </TextStyles>
            </div>
            <div className="border border-solid border-grey-500 rounded-lg">
              <div className="py-6 px-4">
                {reportType.map((report, index) => (
                  <div key={index} className="mb-4">
                    <div className="border border-solid border-grey-500 rounded-lg">
                      <div className="flex justify-between items-center p-5">
                        <p className="my-auto text-base font-light">
                          {report.label}
                        </p>
                        <div
                          onClick={() => handleSelect(report.value)}
                          className={`border-[2px] border-solid w-6 h-6 rounded-sm flex items-center justify-center cursor-pointer
                        ${
                          selectedReport === report.value
                            ? "border-none bg-[#06513D]"
                            : "border-gray-400"
                        }`}
                        >
                          {selectedReport === report.value && (
                            <span className="text-white text-sm">&#10003;</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </DailogBox>
        )}
      </div>
      {automaticReportPopup && (
        <AutomaticReportPopup
          open={automaticReportPopup}
          onCancel={() => setAutomaticReportPopup(false)}
        />
      )}

      {manualReportPopup && (
        <ManualReportPop
          open={manualReportPopup}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
};

export default GenerateReport;
